export const MOBILE_REG = /^(\+98|0)?9\d{9}$/g;
export const USERNAME_REG = /^[-_A-Za-z0-9]+$/;
export const CHASSIS_REG = /^[A-Za-z0-9]+$/;
export const LOCATION_REG = /^(-?\d+(\.\d+)?),(-?\d+(\.\d+)?)$/;
export const CAPTCHA_REG = /^[a-zA-Z0-9]{6}$/;
